import { useTranslation } from "react-i18next";
import { CommissionComment } from "../../../api/ComissionContractsAPI";
import SectionTitle from "../../SectionTitle/SectionTitle";
import TextArea from "../../TextArea/TextArea";
import PrimaryButton from "../../PrimaryButton/PrimaryButton";
import NoData from "../../NoData/NoData";
import CommentCard from "../../CommentCard/CommentCard";

interface CommentsTabSectionProps {
  comments: CommissionComment[];
  commentDraft: string;
  storeName: string;
  isLoading: boolean;
  onCommentDraftChange: (value: string) => void;
  onAddComment: () => void;
}

export default function CommentsTabSection({
  comments,
  commentDraft,
  storeName,
  isLoading,
  onCommentDraftChange,
  onAddComment,
}: CommentsTabSectionProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <SectionTitle text={t("store_commission_panel.comments_title") || "Comments"} />
      <div className="text-xs text-gray-500 px-1">
        {t("store_commission_panel.comments_explanation") ||
          "Comments you add here will be visible to the bride and can help with communication."}
      </div>
      <div className="max-h-80 py-2 px-1 overflow-y-auto space-y-3">
        {comments.length > 0 ? (
          comments.map((item) => (
            <CommentCard
              key={item.id}
              comment={item}
              type="commission"
              isSelf={item.writtenBy === storeName}
            />
          ))
        ) : (
          <NoData message={t("store_commission_panel.no_comments") || "No comments"} />
        )}
      </div>
      <div className="space-y-2">
        <TextArea
          label={t("store_commission_panel.add_comment") || "Add comment"}
          defaultValue={commentDraft}
          onChange={(e) => onCommentDraftChange(e.target.value)}
          isDisabled={isLoading}
        />
        <div className="w-full">
          <PrimaryButton
            text={t("store_commission_panel.add_button") || "Add"}
            fn={onAddComment}
            isDisabled={isLoading || !commentDraft.trim()}
          />
        </div>
      </div>
    </div>
  );
}
